<template>
    <b-carousel :interval="3000" indicators>
        <b-carousel-slide v-if="slide.type == 1" v-for="(slide, index) in slides" :img-src="getIcon(slide.images.image)" :key="index"
                          :img-alt="'LentaSlot - Online Casino '+slide.title"></b-carousel-slide>
    </b-carousel>
</template>

<script>
  import Config from "@/config";

  export default {
    computed: {
      slides() {
        return this.$store.getters['getSlides']
      }
    },
    methods: {
      getIcon(icon) {
        return Config.mainStorageUrl + icon;
      }
    }
  }
</script>

<style>
    .carousel-indicators li {
        border-radius: 50%;
        height: 12px !important;
        width: 12px !important;
        border: 1px solid #f6d307d9 !important;
        background: transparent !important;
    }

    .carousel-indicators li.active {
        background-image: linear-gradient(#f6d307d9, #96731e) !important;
    }
</style>
